import euroWithBackground from './svg/euroWithBackground.svg?url';

export const EuroWithBackgroundIcon = () => {
	return <img src={euroWithBackground} alt="Euro Icon" />;
};
